// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gSWO","actions":"styles_actions__2O9Bu","error":"styles_error__3MdS0","message":"styles_message__kNQNM"};